<div class="flex gap-2 p-2">
  <button
    type="button"
    pButton
    label="Pause Algo ETL Queue"
    [disabled]="pauseEtlQueueDisabled"
    (click)="onPauseAlgoETLQueueClick()"
  ></button>
  <a href="/hangfire" target="_blank">
    <button type="button" pButton label="Open Dashboard"></button>
  </a>
</div>

<p-table [value]="recurringJobs" dataKey="id" editMode="row" [(selection)]="selectedJob">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th>Method Name</th>
      <th>Desc</th>
      <th>CronSchedule</th>
      <th style="width: 170px"></th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-job
    let-columns="columns"
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr [pEditableRow]="job">
      <td>{{ job.methodName }}</td>
      <td>{{ job.description }}</td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              *ngIf="scheduleFormControls[job.id]"
              pInputText
              type="text"
              [formControl]="scheduleFormControls[job.id]"
            />
            <div
              class="text-red-600"
              *ngIf="scheduleFormControls[job.id] && scheduleFormControls[job.id].invalid"
            >
              {{ scheduleFormControls[job.id].errors.invalidCronExpression.message }}
            </div>
          </ng-template>
          <ng-template pTemplate="output">
            <div *ngIf="job.isActive">{{ job.cronSchedule | cronHumanize }}</div>
            <div *ngIf="!job.isActive">DISABLED</div>
            <div class="mt-2 text-xs text-gray-700">
              Last Updated: {{ job.scheduleUpdated | datex : "ddd DD MMM 'YY HH:mm" }} by
              {{ job.updatedByUserName }}
            </div>
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center">
        <button
          *ngIf="!editing"
          pButton
          type="button"
          pInitEditableRow
          icon="pi pi-pencil"
          class="ui-button-info"
          (click)="onScheduleEditInit(job)"
        ></button>
        <button
          *ngIf="editing"
          pButton
          type="button"
          pSaveEditableRow
          icon="pi pi-check"
          class="ui-button-success"
          style="margin-right: 0.5em"
          (click)="onScheduleEditSave(job, ri)"
        ></button>
        <button
          *ngIf="editing"
          pButton
          type="button"
          pCancelEditableRow
          icon="pi pi-times"
          class="ui-button-danger"
          (click)="onScheduleEditCancel(job, ri)"
        ></button>
        <button
          *ngIf="!editing"
          [disabled]="!job.isActive"
          pButton
          type="button"
          icon="pi pi-times"
          class="ui-button-danger"
          (click)="onDisableClick(job)"
        ></button>
        <button
          pButton
          pTooltip="Run Job"
          type="button"
          icon="fa fa-play"
          class="ui-button-success"
          [disabled]="runJobLoading"
          (click)="onRunClick(job)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align: left">
      <button
        type="button"
        pButton
        icon="pi pi-plus"
        (click)="onCreateClick()"
        label="Add"
      ></button>
    </div>
  </ng-template>
</p-table>

<hangfire-job-dialog
  [(visible)]="createVisible"
  (formSubmitted)="onCreateSubmitted($event)"
></hangfire-job-dialog>
